module.exports = __webpack_public_path__ + "static/keyword_4-ec2e704d76aa3a3b69b402ab7c6082f9.jpg";